<template>
  <div class="fatherBox">
    <div class="logo">
      <img src="https://img.yzcdn.cn/vant/cat.jpeg" />
    </div>
    <div class="forms">
      <van-field
        class="inputs"
        v-model="form.userName"
        :left-icon="require('@/assets/email.png')"
        placeholder="请输入电子邮箱"
      />
      <van-field
        class="inputs"
        v-model="form.password"
        type="password"
        :left-icon="require('@/assets/code.png')"
        placeholder="请输入验证码"
      >
        <template #button>
          <span class="txtBtn">发送验证码</span>
        </template>
      </van-field>
      <van-field
        class="inputs"
        v-model="form.userName"
        :left-icon="require('@/assets/password.png')"
        placeholder="请设置6-20位新密码"
      />
      <van-button class="bnt">确定</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {}
    };
  }
};
</script>
<style lang="scss" scoped>
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.8rem;
  margin-bottom: 0.4rem;
  img {
    height: 1.62rem;
  }
}
.forms {
  text-align: center;
  .inputs {
    width: 6.4rem;
    height: 0.88rem;
    border: 1px solid rgba(204, 204, 204, 1);
    border-radius: 1rem;
    margin: 0 auto 0.6rem;
    font-weight: 400;
    color: rgba(43, 47, 56, 1);
    background: transparent;
    /deep/ .van-field__value {
      display: flex;
    }
    /deep/ .van-field__body {
      width: 100%;
    }
    /deep/ .van-field__left-icon {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .txtBtn {
    font-size: 0.24rem;
    font-weight: 400;
    line-height: 0.33rem;
    color: rgba(38, 128, 235, 1);
    display: block;
  }
  .bnt {
    display: block;
    width: 6.4rem;
    height: 0.88rem;
    line-height: 0.88rem;
    border: 1px solid rgba(204, 204, 204, 1);
    border-radius: 1rem;
    margin: 0.8rem auto 0.4rem;
    font-size: 0.24rem;
    font-weight: 400;
    color: rgba(43, 47, 56, 1);
    letter-spacing: 0.1rem;
    background: transparent;
  }
  p {
    margin-top: 1rem;
    font-size: 0.24rem;
    font-weight: 400;
    line-height: 0.33rem;
    color: rgba(43, 47, 56, 1);
    .txtBtn {
      display: inline;
    }
  }
}
.fatherBox {
  background: #fafafa;
  min-height: 100vh;
}
</style>